<template>
    <div class="echart-box">
        <v-chart
            :options="option"
            ref="my"
            autoresize
        />
    </div>
</template>
<script>
import ECharts from "vue-echarts";
import "echarts/lib/component/legend";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/polar";
import "zrender/lib/svg/svg";
import { setTimeout } from "timers";
export default {
  name: "char1",
  components: {
    "v-chart": ECharts
  },
  props: {
    data: Object,
    rotate:{
      type:String,
      default:()=>"0"
    },
    datelist: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      option: {},
      viewdata: {},
      viewdate: []
    };
  },
  watch: {
    datelist: {
      handler() {
        
        this.dataInit();
        this.init();
      },
      deep: false
    }
  },
  methods: {
    dataInit() {
      this.viewdata.data1 = this.data.actual.slice(0, 5);
      this.viewdata.data2 = this.data.average.slice(0, 5);
      this.viewdate = this.datelist.slice(0, 5);
      this.doit();
    },
    init() {
      this.option = {
        grid: {
          top: "10%",
          left: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true
        },
        legend: {
          bottom: "2%",
          itemWidth: 6,
          itemHeight: 6,
          textStyle: {
            color: "#fff"
          },
          icon: "rect",
          data: ["实际工时", "工时平衡率", "工时达成率"]
        },
        tooltip: {
          formatter: function(params, index) {
            var result = params[0].name + "</br>";
            params.forEach(function(item) {
              if (item.seriesId == "a1") {
                result += item.seriesName + ":" + item.data + "</br>";
              } else if (item.seriesId == "a2") {
                //活跃会员数
                result += item.seriesName + ":" + item.data + "%</br>";
              } else if (item.seriesId == "a3") {
                //活跃会员数
                result += item.seriesName + ":" + item.data + "%</br>";
              } else {
                result += item.seriesName + ":" + item.data + "</br>";
              }
            });
            return result;
          },
          textStyle: {
            fontSize: this.chartFontSize
          },
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(246, 232, 87,0)" // 0% 处的颜色
                  },
                  {
                    offset: 0,
                    color: "rgba(234, 205, 44,0.4)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        },
        xAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: "#323645",
              type: "solid",
              width: 1
            },
            minInterval: 0
          },
          axisLabel: {
            color: "#fff",
            rotate:this.rotate
          },
          type: "category",
          data: this.viewdate
        },
        yAxis: {
          axisLabel: {
            color: "#fff"
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#323645",
              type: "dashed",
              width: 1
            },
            minInterval: 0
          },
          type: "value"
        },
        series: [
          {
            id: "a1",
            name: "实际工时",
            data: this.viewdata.data1,
            type: "bar",
            markLine: {
              lineStyle: {
                type: "solid",
              },
              data: [{ type: "average", name: "平均线" }]
            },
            // type: 'line',
            itemStyle: {
              normal: {
                color: "#8943D3"
              }
            },
            barWidth: this.barWidth,
            

          },
          {
            id: "a2",
            name: "工时平衡率",
            data: this.viewdata.data2,
            //  type: 'bar',
            type: "line",
            itemStyle: {
              normal: {
                color: "#01B6F8"
              }
            },
            barWidth: this.barWidth,
          }
        ]
      };
      setTimeout(()=>{
                  this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 1                     
                    })
                this.$nextTick(()=>{
                    this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 2                     
                    })
                })
            },500)  
    },
    rundata() {
      this.data.actual.push(this.data.actual.shift());
      this.data.average.push(this.data.average.shift());
      this.datelist.push(this.datelist.shift());
    },
    //动画
    doit() {
      let that = this;
      setTimeout(() => {
        that.rundata();
      }, 3000);
    }
  },
  mounted() {
    //   this.init()
  }
};
</script>